import { AppState, Auth0Provider } from '@auth0/auth0-react'
import { ReactElement, ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const Auth0ProviderWithNavigate = ({
    children,
}: {
    children: ReactNode
}): ReactElement | null => {
    const navigate = useNavigate()

    const domain = import.meta.env.VITE_AUTH0_DOMAIN
    const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
    const redirectUri = import.meta.env.VITE_AUTH0_CALLBACK_URL
    const audience = import.meta.env.VITE_AUTH0_AUDIENCE
    const entityMgmtPath = import.meta.env.VITE_API_ENTITY_MGMT_URL

    const onRedirectCallback = (appState: AppState | undefined) => {
        navigate(appState?.returnTo || window.location.pathname)
    }

    const location = useLocation()

    const paramsObject: any = {}
    if (location.search.includes('invitation=')) {
        const url = window.location.href
        const queryParams = new URLSearchParams(url.split('?')[1])
        for (const [key, value] of queryParams.entries()) {
            paramsObject[key] = value
        }
    }

    if (!(domain && clientId && redirectUri)) {
        return null
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: redirectUri,
                audience,
                'ext-entity-mgmt-path': entityMgmtPath,
                'ext-redirect-uri': redirectUri,
                ...paramsObject,
            }}
            onRedirectCallback={onRedirectCallback}
            cacheLocation="localstorage"
            useRefreshTokens={true}
        >
            {children}
        </Auth0Provider>
    )
}
